import { defineStore } from 'pinia';
import { DealersRequestFilter } from '@/types/dealer.type.ts';

export const useDealersFilterStore = defineStore('dealers.filter', {
    state: (): DealersRequestFilter => ({
        page: 1,
        sort: [{ name: 'asc' }],
        name: '',
        sap_code: '',
        holding_id: undefined,
        is_hyundai_dealer: undefined,
        is_genesis_dealer: undefined,
        status: undefined,
    }),
});
